import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { UsageStats } from '../../types';
import { bots } from '../../data/bots';

interface UsageDistributionChartProps {
  data: UsageStats[];
}

const COLORS = ['#0891b2', '#6366f1', '#ec4899', '#f59e0b', '#10b981', '#8b5cf6'];

const UsageDistributionChart: React.FC<UsageDistributionChartProps> = ({ data }) => {
  // Group data by bot
  const groupedData = data.reduce((acc, curr) => {
    const bot = bots.find(b => b.id === curr.botId) || 
                bots.flatMap(b => b.subBots || []).find(sb => sb.id === curr.botId);
    
    const botTitle = bot?.title || curr.botTitle || 'Unknown Bot';
    
    if (!acc[curr.botId]) {
      acc[curr.botId] = {
        name: botTitle,
        value: 0
      };
    }
    acc[curr.botId].value += 1;
    return acc;
  }, {} as Record<string, { name: string; value: number }>);

  const chartData = Object.values(groupedData);

  return (
    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label={({ name, value, percent }) => 
              `${name} (${value} uses, ${(percent * 100).toFixed(0)}%)`
            }
          >
            {chartData.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value, name) => [`${value} uses`, name]}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UsageDistributionChart;